import { render } from "./BestSelling.vue?vue&type=template&id=7ee201b3&scoped=true"
import script from "./BestSelling.vue?vue&type=script&lang=js"
export * from "./BestSelling.vue?vue&type=script&lang=js"

import "./BestSelling.vue?vue&type=style&index=0&id=7ee201b3&scoped=true&lang=css"
import "./BestSelling.vue?vue&type=style&index=1&id=7ee201b3&scoped=true&lang=css"

import exportComponent from "F:\\App-themes\\clickon\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ee201b3"]])

export default __exports__